export class PrinterSendRequest {
  printType?: string;
  data?: string;
  byteData?: number[];
  printerName?: string | null;
  count?: number;
  layout?: string;
  height?: number;
  width?: number;
}
